import {
  Observable,
  merge,
  buffer,
  skipUntil,
  map,
  mergeAll,
  take,
} from 'rxjs';

export function bufferUntil<T>(
  thingToBuffer$: Observable<T>,
  endBuffering$: Observable<unknown>,
) {
  // There are other possible way to do this like bufferWhen as an operator but this seemed the easiest to convey
  return merge(
    thingToBuffer$.pipe(buffer(endBuffering$), take(1)),
    thingToBuffer$.pipe(
      skipUntil(endBuffering$),
      // turns the non buffered items into an array so that they can be flattened by the mergeAll later
      map((val) => [val]),
    ),
  ).pipe(
    // flattens the array return
    mergeAll(),
  );
}
